import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import routes from "routes";
import FixedPlugin from "components/fixedPlugin/FixedPlugin";
import SignInDefault from "views/auth/signIn/SignInDefault";
import VerificationDefault from "views/auth/verification/VerificationDefault";

export default function Auth() {

  return (
    <div>
      <div className="relative float-right h-full min-h-screen w-full dark:!bg-navy-900">
        <main className={`mx-auto min-h-screen`}>
          <Routes>
       
            <Route path="/"  element={<SignInDefault />}   />
            <Route path="/otp"  element={<VerificationDefault />}   />

            <Route
              path="/"
              element={<Navigate to="/auth/" replace />}
            />
          </Routes>
        </main>
      </div>
    </div>
  );
}
